export default "__VITE_ASSET__BcJBp$wF__"